module.exports = __webpack_public_path__ + "img/smalldot.54e214f7.png";